export var userSelfEditActions = {
    SHOW_SELF_EDIT_USER_MODAL: 'SHOW_SELF_EDIT_USER_MODAL',
    HIDE_SELF_EDIT_USER_MODAL: 'HIDE_SELF_EDIT_USER_MODAL',
    SHOW_SELF_EDIT_USER_LIST: 'SHOW_SELF_EDIT_USER_LIST',
    HIDE_SELF_EDIT_USER_LIST: 'HIDE_SELF_EDIT_USER_LIST',
    SHOW_SELF_EDIT_PASS_MODAL: 'SHOW_SELF_EDIT_PASS_MODAL',
    HIDE_SELF_EDIT_PASS_MODAL: 'HIDE_SELF_EDIT_PASS_MODAL',
};



//////////////////
// WEBPACK FOOTER
// ./src/actions/userSelfEditActions.ts
// module id = 90
// module chunks = 0